import React from 'react';

const SvgMg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MG_svg__b" fill="#fff">
        <use xlinkHref="#MG_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M9.333 9.333H28V20H9.333V9.333z"
        fill="#149047"
        mask="url(#MG_svg__b)"
      />
      <path
        d="M9.333 0H28v9.333H9.333V0z"
        fill="#F84F4B"
        mask="url(#MG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMg;
